import { forOwn } from "lodash-unified";
let _id_ = 0;
const flattenTree = (data, keys, level = 0, pid = 0, childrenKey = "child") => data.reduce((arr, x) => [
  ...arr,
  keys.reduce((o, k) => (o[k] = x[k], o), { level, pid }),
  ...flattenTree(x[childrenKey] || [], keys, level + 1, x.id, childrenKey)
], []);
const findTreeNode = (data, target, options = { key: "id", children: "children" }) => {
  let result = null;
  const find = (data2) => {
    var _a;
    for (let i = 0; i < data2.length; i++) {
      if (data2[i][options.key] === target) {
        result = data2[i];
      }
      if ((_a = data2[i][options.children]) == null ? void 0 : _a.length) {
        find(data2[i][options.children]);
      }
    }
  };
  find(data);
  return result;
};
function splitPromises(promises, groupNum = Number.MAX_SAFE_INTEGER) {
  const chunks = promises.reduce((previous, current, index) => {
    const remainder = index % groupNum;
    if (!previous[remainder]) {
      previous.push([]);
    }
    previous[remainder].push(current);
    return previous;
  }, []);
  return chunks;
}
function handleDownloadFile(originalName, url) {
  const link = document.createElement("a");
  link.style.display = "none";
  link.href = url;
  link.setAttribute("download", originalName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
function handleFileBuffer(response, defaultFileName = "file.dat") {
  var _a;
  let filename = response.headers["attachment-name"];
  if (!filename) {
    filename = ((_a = response.headers["content-disposition"]) == null ? void 0 : _a.split("filename=")[1]) || defaultFileName;
  }
  const url = window.URL.createObjectURL(new Blob([response.data]));
  handleDownloadFile(decodeURIComponent(filename), url);
}
const downloadFile = (filename, url) => {
  const xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function() {
    const urlCreator = window.URL || window.webkitURL;
    const imageUrl = urlCreator.createObjectURL(this.response);
    const tag = document.createElement("a");
    tag.href = imageUrl;
    tag.target = "_blank";
    tag.download = filename;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
  xhr.onerror = (err) => {
    alert("Failed to download file:" + err);
  };
  xhr.send();
};
function echartsFontSize(res, basisHeight) {
  const clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  if (!clientHeight)
    return;
  const fontSize = clientHeight / basisHeight;
  return res * fontSize;
}
function toQuery(obj) {
  const results = [];
  forOwn(obj, (value, key) => {
    if (Array.isArray(value)) {
      forOwn(value, (val) => {
        results.push(`${key}=${val}`);
      });
    } else {
      results.push(`${key}=${value}`);
    }
  });
  return results.join("&");
}
function random() {
  return String(Math.random());
}
function seqID() {
  return _id_++;
}
const disableFutureDate = (time) => {
  const d2 = new Date();
  return time.getTime() > d2.getTime();
};
const CommonUtils = {
  handleFileBuffer,
  handleDownloadFile,
  downloadFile,
  splitPromises,
  flattenTree,
  findTreeNode,
  echartsFontSize,
  toQuery,
  random,
  seqID,
  disableFutureDate
};
export { CommonUtils };
